import React, { useEffect, useMemo, useState } from 'react';

// DurationTimer
// Shows elapsed time since a start timestamp.
// Format:
// - Under 1 hour: M:SS (minutes no leading zero, seconds always 2 digits)
// - 1 hour or more: H:MM:SS (H no leading zero, MM/SS two digits)
// Updates ~5 times per second (every 200ms) so the display stays in sync and
// doesn't appear to skip seconds on slower clocks. No network calls are made.
// Props:
// - start: Date | string | number
// - className?: string

function toDate(val) {
  if (!val) return null;
  if (val instanceof Date) return val;
  if (typeof val === 'number') return new Date(val);
  return new Date(String(val));
}

function pad2(n) {
  return n < 10 ? `0${n}` : `${n}`;
}

function formatElapsed(ms) {
  if (!ms || ms < 0) ms = 0;
  const totalSeconds = Math.floor(ms / 1000);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  if (h > 0) return `${h}:${pad2(m)}:${pad2(s)}`;
  return `${m}:${pad2(s)}`;
}

export default function DurationTimer({ start, className = '' }) {
  const startDate = useMemo(() => toDate(start), [start]);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!startDate) return;
    const id = setInterval(() => setNow(Date.now()), 200);
    return () => clearInterval(id);
  }, [startDate]);

  if (!startDate) return <span className={className}>0:00</span>;
  const elapsed = now - startDate.getTime();
  return <span className={className}>{formatElapsed(elapsed)}</span>;
}
